import { useState } from 'react'

interface Props {
  assessment: Record<string, any>
  onSave: (data: Record<string, any>) => void
  onCancel: () => void
}

export default function AssessmentForm({ assessment, onSave, onCancel }: Props) {
  const [formData, setFormData] = useState(assessment.form_data || {})

  const handleInputChange = (field: string, value: any) => {
   setFormData((prev: Record<string, any>) => ({
      ...prev,
      [field]: value
    }))
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onSave({
      ...assessment,
      form_data: formData,
      updated_at: new Date().toISOString(),
      status: 'submitted'
    })
  }

  return (
    <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Site Name *</label>
          <input
            type="text"
            value={formData.site_name || ''}
            onChange={(e) => handleInputChange('site_name', e.target.value)}
            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-irrigonics-600 focus:border-transparent"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Client Name</label>
          <input
            type="text"
            value={formData.client_name || ''}
            onChange={(e) => handleInputChange('client_name', e.target.value)}
            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-irrigonics-600 focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Survey Date *</label>
          <input
            type="date"
            value={formData.survey_date || ''}
            onChange={(e) => handleInputChange('survey_date', e.target.value)}
            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-irrigonics-600 focus:border-transparent"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Assessor Name *</label>
          <input
            type="text"
            value={formData.assessor_name || ''}
            onChange={(e) => handleInputChange('assessor_name', e.target.value)}
            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-irrigonics-600 focus:border-transparent"
            required
          />
        </div>
      </div>

      <div className="border-t pt-6">
        <h3 className="text-lg font-semibold mb-4">Compliance Checklist</h3>
        <div className="space-y-3">
          {[
            { key: 'written_scheme_present', label: 'Written scheme in place?' },
            { key: 'logbook_present', label: 'Legionella log book present?' },
            { key: 'staff_training_records', label: 'Staff training records available?' },
            { key: 'training_current', label: 'Training current?' },
            { key: 'technical_drawings_present', label: 'Water services drawings available?' },
          ].map(item => (
            <label key={item.key} className="flex items-center">
              <input
                type="checkbox"
                checked={formData[item.key] || false}
                onChange={(e) => handleInputChange(item.key, e.target.checked)}
                className="rounded border-gray-300 text-irrigonics-600 focus:ring-irrigonics-600"
              />
              <span className="ml-2 text-sm text-gray-700">{item.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="flex gap-3 justify-end pt-6 border-t">
        <button
          type="button"
          onClick={onCancel}
          className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 font-medium transition"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-6 py-2 bg-irrigonics-600 hover:bg-irrigonics-700 text-white rounded-lg font-medium transition"
        >
          Save Assessment
        </button>
      </div>
    </form>
  )
}
